'use client';

import type { ReactNode } from 'react';

import i18next from 'i18next';
import { useMemo } from 'react';
import { getStorage } from 'minimal-shared/utils';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, I18nextProvider as Provider } from 'react-i18next';

import { CONFIG } from 'src/global-config';

import { i18nOptions, fallbackLng } from './locales-config';

// ----------------------------------------------------------------------

let lng: string | undefined;

/**
 * [1] localStorage
 * Auto detection:
 * const lng = getStorage('i18nextLng')
 */
if (CONFIG.isStaticExport) {
  // getStorage 선언은 null 을 포함하지만 defaultValue 를 주면 구현상 null 은 반환되지 않는다(?? 'ko') — 단언은 타입 좁히기뿐
  lng = getStorage('i18nextLng', fallbackLng) as string | undefined;
}

const init = CONFIG.isStaticExport
  ? { ...i18nOptions(lng), detection: { caches: ['localStorage'] } }
  : { ...i18nOptions(), detection: { caches: ['cookie'] } };

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(resourcesToBackend((lang: string, ns: string) => import(`./langs/${lang}/${ns}.json`)))
  .init(init);

// ----------------------------------------------------------------------

type I18nProviderProps = {
  lang?: string;
  children: ReactNode;
};

export function I18nProvider({ lang, children }: I18nProviderProps) {
  useMemo(() => {
    if (lang) {
      i18next.changeLanguage(lang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Provider i18n={i18next}>{children}</Provider>;
}
